'use client'

import { motion } from 'framer-motion'

export default function LazyPricingTable() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="mb-12 text-center"
      >
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          Mit GoDeutschland können Sie <span className="text-[#ff4500]">4.533 € </span>beim PV-Kauf
          einsparen
        </h2>
        <p className="mx-auto mt-8 max-w-3xl text-lg text-gray-600">
          Vergleichen Sie die Nettopreise durchschnittlicher PV-Anlagen und treffen Sie eine
          fundierte Entscheidung.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mx-auto overflow-hidden rounded-lg shadow-lg"
      >
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#ff4500] text-white">
                <th className="px-6 py-4 text-left text-sm font-semibold sm:text-base">
                  Leistung PV-Anlage
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold sm:text-base">
                  Kosten PV-Anlage ohne Speicher
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold sm:text-base">
                  Kosten PV-Anlage mit Speicher
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold sm:text-base">
                  GoDeutschland Preis mit Speicher
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200 bg-white">
                <td className="px-6 py-4 text-left text-sm font-medium text-gray-900 sm:text-base">
                  4 kWp
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  8.724 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  13.925 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm font-medium text-[#ff4500] sm:text-base">
                  12.018,39 Euro
                </td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="px-6 py-4 text-left text-sm font-medium text-gray-900 sm:text-base">
                  8,5 kWp
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  13.121 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  18.322 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm font-medium text-[#ff4500] sm:text-base">
                  13.597 Euro
                </td>
              </tr>
              <tr className="border-b border-gray-200 bg-white">
                <td className="px-6 py-4 text-left text-sm font-medium text-gray-900 sm:text-base">
                  10 kWp
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  14.232 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  19.433 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm font-medium text-[#ff4500] sm:text-base">
                  14.280 Euro
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="px-6 py-4 text-left text-sm font-medium text-gray-900 sm:text-base">
                  13 kWp
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  17.536 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-700 sm:text-base">
                  22.737 Euro
                </td>
                <td className="px-6 py-4 text-center text-sm font-medium text-[#ff4500] sm:text-base">
                  16.453,59 Euro
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-gray-50 px-6 pt-3 text-xs text-gray-500 sm:text-sm">
          Quelle: zolar; diese Nettopreise enthalten die Installation, alle notwendigen Komponenten
          sowie ein Rundum-Schutzpaket mit Versicherung und Garantien
        </div>
        <div className="bg-gray-50 px-6 py-3 text-xs font-bold text-gray-600 sm:text-sm">
          *(10.4 kWp, 10,66 kWh Batteriespeicher, Wechselrichter, Unterkonstruktion, Eon
          Energiemanager, bundesweite Installation, Inbetriebnahme)
        </div>
      </motion.div>
    </div>
  )
}
